import { Form } from "react-bootstrap";

export const DEFAULT_ITEMS_PER_PAGE = 10;
export const SORT_ORDER = "desc";
export const LIST_DEF_SORT = "createdDate";
export const ITEMS_COUNT_PAGINATION_OPTION = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
];
export const FORMTYPES = [
  { value: "SUPPLIERASSESSMENT", label: "Supplier Assessment" },
  { value: "SELFASSESSMENT", label: "Self Assessment" },
  { value: "MATERIALITY", label: "Materiality" }
];

export const FORMCONTROLLERSTYPE = [
  {
    icon: "BiText",
    name: "Single line text",
    key: "SINGLE_TEXTBOX",
  },
  {
    icon: "BiHash",
    name: "Numeric field",
    key: "NUMERIC_VALUE",
  },
  {
    icon: "BiParagraph",
    name: "Paragraph",
    key: "TEXT_BOX",
  },
  {
    icon: "BiListUl",
    name: "Single select field",
    key: "DROP_DOWN",
  },
  {
    icon: "BiListCheck",
    name: "Multi select field",
    key: "MULTI_SELECT_DROP_DOWN",
  },
  {
    icon: "BiRadioCircleMarked",
    name: "Radio button",
    key: "RADIO",
  },
  {
    icon: "BiRadioCircleMarked",
    name: "Radio button grid",
    key: "RADIO_GRID",
  },
  {
    icon: "BiCheckSquare",
    name: "Checkbox",
    key: "MULTIPLE_CHOICE",
  },
  {
    icon: "BiCalendarAlt",
    name: "Date",
    key: "DATE_TIME_BOX",
  },
  {
    icon: "BiCalendar",
    name: "Date Range",
    key: "DATE_RANGE",
  },
  {
    icon: "BiUpload",
    name: "File upload",
    key: "FILE_UPLOAD",
  },
  {
    icon: "BiStar",
    name: "Rating",
    key: "RATING",
  },
  {
    icon: "BiTable",
    name: "Table",
    key: "TABLE",
  },
  {
    icon: "BiGridAlt",
    name: "Grid",
    key: "GRID",
  },

  // {
  //   icon: "BiRadioCircleMarked",
  //   name: "Slider",
  //   key: "SLIDER",
  // },
  // {
  //   icon: "BiRadioCircleMarked",
  //   name: "Search",
  //   key: "SEARCH_BOX",
  // },
  // {
  //   icon: "BiRadioCircleMarked",
  //   name: "Email",
  //   key: "EMAIL",
  // },
  // {
  //   icon: "BiRadioCircleMarked",
  //   name: "Yes_No",
  //   key: "YES_NO",
  // },
];
export const STATUS =
{
  DRAFT: "Draft",
  PUBLISHED: "Published",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  ARCHIVED: "Archived"
}
  ;

export const SCORINGMETHODS = [
  {
    name: "None",
    key: "NONE",
  },
  {
    name: "Average",
    key: "AVERAGE",
  },
  {
    name: "Sum",
    key: "SUM",
  },
];

export const ASSESSMENTFORMTXT = 'ASSESSMENT';
export const COMPLETED_STATUS = 'COMPLETED';
export const PUBLISHEDSTATUSTXT = 'PUBLISHED';
export const GENERAL_FORM = 'GENERAL';

export const FormLogicOperation = {
  AND: 'AND',
  OR: 'OR',
  EQUAL: 'EQUAL',
  NOT_EQUAL: 'NOT_EQUAL',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN_EQUAL: 'LESS_THAN_EQUAL',
  GREATER_THAN_EQUAL: 'GREATER_THAN_EQUAL'
};

export const LogicOperations = [
  { id: FormLogicOperation.AND, text: "And" },
  { id: FormLogicOperation.OR, text: "Or" },
  { id: FormLogicOperation.EQUAL, text: "Equal To" },
  { id: FormLogicOperation.NOT_EQUAL, text: "Not Equal To" },
  { id: FormLogicOperation.LESS_THAN, text: "Less Than" },
  { id: FormLogicOperation.GREATER_THAN, text: "Greater Than" },
  { id: FormLogicOperation.LESS_THAN_EQUAL, text: "Less Than or Equal To" },
  { id: FormLogicOperation.GREATER_THAN_EQUAL, text: "Greater Than or Equal To" }
];

export const FormLogicAction = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  SKIP_TO: 'SKIP_TO'
};

// Local storage keys
export const LS_REDIRECT_URL_KEY = 'redirectUrl';
export const LS_ACCESS_TOKEN_KEY = 'accessToken';
export const LS_RETURN_PARAMS_KEY = 'returnParams';

export const QuestionType = {
  RADIO: 'RADIO',
  MULTI_SELECT_DROP_DOWN: 'MULTI_SELECT_DROP_DOWN',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DROP_DOWN: 'DROP_DOWN',
  RATING: 'RATING',
  NUMERIC_VALUE: 'NUMERIC_VALUE',
  SINGLE_TEXTBOX: 'SINGLE_TEXTBOX',
  DATE_TIME_BOX: 'DATE_TIME_BOX',
  DATE_RANGE: 'DATE_RANGE',
  TEXT_BOX: 'TEXT_BOX',
  FILE_UPLOAD: 'FILE_UPLOAD',
  SLIDER: 'SLIDER',
  SEARCH_BOX: 'SEARCH_BOX',
  EMAIL: 'EMAIL',
  YES_NO: 'YES_NO',
  RADIO_GRID: 'RADIO_GRID',
  TABLE: 'TABLE',
  GRID: 'GRID'
};

export const FormStatus = {
  COMPLETED: 'COMPLETED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  CORRECTION_PENDING: 'CORRECTION_PENDING'
};

// Events
export const FORM_REVIEW_APPROVED_EVENT = 'FORM_REVIEW_APPROVED';
export const FORM_REVIEW_REJECTED_EVENT = ' FORM_REVIEW_REJECTED';

export const ExternalDependencyType = {
  EMISSION_CALCULATOR: 'EMISSION_CALCULATOR'
};

export const EmissionScope = {
  SCOPE_1: {
    label: 'Scope 1',
    text: "Scope 1 emissions are direct emissions from owned or controlled sources.  In other words, emissions are released into the atmosphere as a direct result of a set of activities, at a firm level.",
  },
  SCOPE_2: {
    label: 'Scope 2',
    text: "Scope 2 emissions are indirect emissions from the generation of purchased energy.  In other words, all GHG emissions released in the atmosphere, from the consumption of purchased electricity, steam, heat and cooling.",
  },
  SCOPE_3: {
    label: 'Scope 3',
    text: "Scope 3 emissions are all indirect emissions (not included in scope 2) that occur in the value chain of the reporting company, including both upstream and downstream emissions.",
  }
};

export const FormReviewStatus = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
};

export const FormOptionValidationOperator = {
  EQUAL_TO: 'EQUAL_TO',
  AT_LEAST: 'AT_LEAST',
  AT_MOST: 'AT_MOST',
  BETWEEN: 'BETWEEN'
};

export const LS_FORM_PERMISSIONS_KEY = 'formPermissions';

export const startYear = 2020;

export const TableColumnType = {
  TEXT: 'TEXT',
  NUMERIC: 'NUMERIC'
};